import { BriefingAutoGenerateInsight } from './briefing-auto-gen-insight.model';
import { PrecisionClip } from '../../Shared/models/precision-clip.model';

export class AdditionalSettings {
    autoGenInsight: BriefingAutoGenerateInsight;
    precisionClip: PrecisionClip;
}
